import semver from 'semver'

export const treeToList = (tree, list) => {
  tree?.forEach((item) => {
    treeToList(item?.children, list)
    let { actions, ...other } = item
    list.push(other)
  })
}

export const listToTree = (list, tree, parent_id) => {
  list?.forEach((item) => {
    if (item.parent_id === parent_id) {
      const child = {
        ...item,
        key: item.name,
        children: [],
      }
      listToTree(list, child.children, item.id)
      if (child.children.length <= 0) {
        delete child.children
        if (child.component == 'BasicLayout') {
          return
        }
      }
      tree.push(child)
    }
  })
}

export const rgbToHex = (r, g, b) => {
  return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
}

export const hexToRgb = (hex) => {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b
  })

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null
}

export const getGrayLevelFromRgb = (r, g, b) => {
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255
}

export const getGrayLevel = (hex) => {
  var rgb = hexToRgb(hex)
  return getGrayLevelFromRgb(rgb.r, rgb.g, rgb.b)
}

export const getForegroundColor = (background_color) => {
  var grayLevel = getGrayLevel(background_color)
  return grayLevel > 0.5 ? '#000000b3' : '#fff'
}

export const extractColorByName = (name) => {
  var temp = []
  temp.push('#')
  for (let index = 0; index < name.length; index++) {
    temp.push(parseInt(name[index].charCodeAt(0), 10).toString(16))
  }
  return temp.slice(0, 5).join('').slice(0, 4)
}

const utils = {
  install(app) {
    if (app.utilsInstalled) {
      return
    }
    app.utilsInstalled = true

    let ss = JSON.parse(localStorage.getItem(SelectedServersKey)) || []

    if (semver.lt(app.version, '3.0.0')) {
      Object.defineProperties(app.prototype, {
        $ss: {
          get: function get() {
            return ss
          },
        },
      })
    } else {
      app.config.globalProperties.$ss = ss
    }
    app.$ss = ss
  },
}

export const formatNumber = (num) => {
  for (let i = 0; i < numberName.length; i++) {
    const e = numberName[i]
    if (num >= e.num) {
      return fix2(num / e.num) + e.unit
    }
  }
  return fix2(num)
}

function fix2(num) {
  //如果小数点后为0则去掉
  if (num % 1 === 0) {
    return num
  }
  return num.toFixed(2)
}

const numberName = [
  { num: Math.pow(10, 12), unit: '兆' },
  { num: Math.pow(10, 8), unit: '亿' },
  { num: Math.pow(10, 4), unit: '万' },
]

export default utils

export const SelectedServersKey = 'SelectedServers'

export function getRatio(type) {
  return ratioMap?.[type] || { txt: '￥', ratio: 0.1 }
}

export function parseDouyinLiveAccount(value) {
  const input = (value || '').trim()
  if (/^\d+$/.test(input)) {
    return input
  }
  if (!/^https?:\/\/live\.douyin\.com\/\d+(?:[/?#].*)?$/i.test(input)) {
    return ''
  }
  try {
    const url = new URL(input)
    const roomId = url.pathname.replace(/^\/+|\/+$/g, '')
    return /^\d+$/.test(roomId) ? roomId : ''
  } catch {
    return ''
  }
}

const ratioMap = {
  109: { txt: '￥', ratio: 0.01 }, // 娱公是分
  110: { txt: '￥', ratio: 0.01 }, // 娱公是分
  111: { txt: '$', ratio: 0.01 }, // 美兔是美分
  112: { txt: '$', ratio: 0.01 }, // 锋芒是美分
  113: { txt: '$', ratio: 0.01 }, // YJ是美分
  201: { txt: '$', ratio: 0.01 }, // tiktok是美分
  205: { txt: '¥', ratio: 0.1 }, // 抖音爬虫按平台约定换算
  206: { txt: '$', ratio: 1 / 65 }, // Bigo是美分
  208: { txt: '￥', ratio: 0.001 }, // B站爬虫是厘
  115: { txt: '￥', ratio: 0.01 }, // 月糖直播是分
}

export function getTypeMap(testing) {
  let t = testing ? typeList2 : typeList
  let m = {}
  t.forEach((item) => {
    m[item.Id] = item.Name
  })
  console.log('getTypeMap', t, m)
  return { list: t, map: m }
}

const typeList = [
  { Id: 0, Name: 'Tiktok' },
  { Id: 1, Name: '视频号' },
  { Id: 3, Name: 'B站' },
  { Id: 4, Name: '月糖直播' },
  { Id: 5, Name: '抖音爬虫' },
]
const typeList2 = [
  { Id: 0, Name: 'Tiktok' },
  { Id: 1, Name: '视频号' },
  { Id: 2, Name: 'Bigo' },
  { Id: 3, Name: 'B站' },
  { Id: 4, Name: '月糖直播' },
  { Id: 5, Name: '抖音爬虫' },
]
